import { config } from "config";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <div
        className="d-flex flex-column justify-content-center text-center"
        style={{
          backgroundColor: "var(--hf-color)",
          paddingTop: "1.5rem",
          paddingBottom: "2.5rem",
        }}
      >
        <span className="text-black">
          © {currentYear}, {config.appName}.
        </span>
        <span className="text-black">Todos os direitos reservados</span>
      </div>
    </>
  );
}
